import './src/styles/global.css'

import React from 'react'

import { AuthProvider } from './src/contexts/AuthContext'
import { CampaignProvider } from './src/contexts/CampaignContext.js'
import { FeatureFlagProvider } from './src/contexts/FlagContext'
import { UserProvider } from './src/contexts/UserContext'

export const wrapPageElement = ({ element, props }) => {
  const {
    location,
    data: {
      allContentfulUtmSection: { nodes: utmHomeContents } = { nodes: [] },
      allContentfulProPromoPlan: { nodes: proPromoContents } = { nodes: [] },
    } = {},
  } = props

  return (
    <AuthProvider>
      <UserProvider>
        <FeatureFlagProvider>
          <CampaignProvider
            location={location}
            proPromoContents={proPromoContents}
            utmHomeContents={utmHomeContents}
          >
            {element}
          </CampaignProvider>
        </FeatureFlagProvider>
      </UserProvider>
    </AuthProvider>
  )
}
